declare global {
    interface RouterMeta {
        title: string;
        type?: Number;
    }

    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        params?:any;
        children?: Array<Router>;
        operating?:Array<String>
    }

    interface System {
        import(request: string): Promise<any>
    }

    var System: System
}
// @ts-ignore
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => System.import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => System.import('../views/login.vue')
};
//嵌入
export const oldHddsRouter: Router = {
    path: '/hddsgirdSong',
    name: 'hddsgirdSong',
    meta: {
        title: '运营财务报表'
    },
    component: () => System.import('../views/statistics/girdSong')
};

export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: {title: 'ManageMenu'},
    component: main,
    children: [
        {path: 'home', meta: {title: 'HomePage'}, name: 'home', component: () => System.import('../views/home/home.vue')},
        {path: 'home2', meta: {title: 'HomePage2'}, name: 'home2', component: () => System.import('../views/home/home2.vue')},
    ]
}
//
export const iframeRouters  = {
    path: '/alonepage',
    name: 'alonepage',
    meta: {title: '-'},
    permission: '',
    icon: '&#xe68a;',
    component: main,
    children:[
        {
            path: 'f5',
            meta: {title: '中心管理'},
            permission: 'Pages.Tenants',
            operating:['编辑'],
            name: 'f5',
            component: () => System.import('../views/center/centerManage'),
        },
        {
            path: 'f1',
            meta: {title: '电子病历',url:'hdds/emr/manage.shtml'},
            permission: 'Pages.CaseHistory',
            name: 'f1',
            component: () => System.import('../views/iframe/f1'),
        },
        {
            path: 'realTime',
            meta: {title: '实时监控',},
            permission: 'Pages.RealTime',
            name: 'realTime',
            component: () => System.import('../views/realTime'),
        },
        {
            path: 'f3',
            meta: {title: '临床统计',url:'hdds/report/reportIndex/view.shtml'},
            permission: 'Pages.Statistics',
            name: 'f3',
            component: () => System.import('../views/iframe/f1'),
        },
        {
            path: 'healthPropaganda',
            meta: {title: '健康宣教'},
            permission: 'Pages.Health',
            operating:['新增','编辑','删除'],
            name: 'healthPropaganda',
            component: () => System.import('../views/healthPropaganda'),
        },
    ]
}
// @ts-ignore
// @ts-ignore
export const appRouters: Array<Router> = [
    // {
    //     path: '/patientManagement',
    //     name: 'patientManagement',
    //     permission: '',
    //     meta: {title: '患者管理'},
    //     icon: '&#xe68a;',
    //     component: main,
    //     children: [
    //         {
    //             path: 'info',
    //             meta: {title: '患者信息'},
    //             name: 'info',
    //             component: () => System.import('../views/patientManagement/info')
    //         },
    //         {
    //             path: 'patientstatistics',
    //             meta: {title: '患者统计'},
    //             name: 'patientstatistics',
    //             component: () => System.import('../views/patientManagement/statistics')
    //         },
    //         { path: 'cureInfo',  meta: { title: '患者治疗信息统计' }, name: 'cureInfo', component: () => System.import('../views/patientManagement/cureInfo') },

    //     ]
    // },
    {
        path: '/equipmentManagement',
        name: 'equipmentManagement',
        permission: 'Pages.MachineManage',
        meta: {title: '设备管理'},
        component: main,
        children: [
            {
                path: 'equipmentType',
                meta: {title: '设备类型'},
                permission: 'Pages.MachineType',
                operating:['新增','编辑'],
                name: 'equipmentType',
                component: () => System.import('../views/equipmentManagement/equipmentType')
            },
            {
                path: 'equipmentRegister',
                meta: {title: '设备登记'},
                permission: 'Pages.MachineAdd',
                operating:['新增','编辑','导入'],
                name: 'equipmentRegister',
                component: () => System.import('../views/equipmentManagement/equipmentRegister')
            },
            {
                path: 'equipmentMaintain',  
                meta: {title: '设备维修'},
                permission: 'Pages.MachineRepair',
                operating:['新增','编辑'],
                name: 'equipmentMaintain',
                component: () => System.import('../views/equipmentManagement/equipmentMaintain')
            },
            {
                path: 'equipmentUpkeep',
                meta: {title: '设备保养'},
                permission: 'Pages.MachineMaintenance',
                operating:['新增','编辑'],
                name: 'equipmentUpkeep',
                component: () => System.import('../views/equipmentManagement/equipmentUpkeep')
            },
            {
                path: 'equipmentDestory',
                meta: {title: '设备报废'},
                permission: 'Pages.MachineScrap',
                operating:['新增','编辑'],
                name: 'equipmentDestory',
                component: () => System.import('../views/equipmentManagement/equipmentDestory')
            },
        ]
    },
    {
        path: '/materialManagement',
        name: 'materialManagement',
        permission: 'Pages.ObjectManage',
        meta: {title: '物资维护'},
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'materialType',
                meta: {title: '物资类型'},
                permission: 'Pages.ObjectType',
                operating:['新增','编辑'],
                name: 'materialType',
                component: () => System.import('../views/materialManagement/materialType')
            },
            {
                path: 'materialClass',
                meta: {title: '物资分类'},
                permission: 'Pages.ObjectCategory',
                operating:['新增','编辑'],
                name: 'materialClass',
                component: () => System.import('../views/materialManagement/materialClass')
            },
            {
                path: 'materialRegistration',
                meta: {title: '物资登记'},
                permission: 'Pages.ObjectAdd',
                operating:['新增','编辑','一键同步'],
                name: 'materialRegistration',
                component: () => System.import('../views/materialManagement/materialRegistration')
            },
        ]
    },
    {
        path: '/shipmentsManagement',
        name: 'shipmentsManagement',
        permission: 'Pages.PurchaseManage',
        meta: {title: '采购发货管理'},
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'shipments',
                meta: {title: '发货管理'},
                permission: 'Pages.ShipManage',
                operating:['详情','发货'],
                name: 'shipments',
                component: () => System.import('../views/shipmentsManagement/shipments')
            },
            {
                path: 'bills',
                meta: {title: '发货单查询'},
                permission: 'Pages.ShipQuery',
                operating:['详情'],
                name: 'bills',
                component: () => System.import('../views/shipmentsManagement/bills')
            },
        ]
    },
    {
        path: '/storehouse',
        name: 'storehouse',
        permission: 'Pages.StockManage',
        meta: {title: '库房管理'},
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'tenantDrugStock',
                meta: {title: '中心药品库存'},
                permission: 'Pages.TenantDrug',
                name: 'tenantDrugStock',
                component: () => System.import('../views/storehouse/tenantDrugStock')
            },
            {
                path: 'tenantConsumablesStock',
                meta: {title: '中心耗材库存'},
                permission: 'Pages.TenantConsumable',
                name: 'tenantConsumablesStock',
                component: () => System.import('../views/storehouse/tenantConsumablesStock')
            },
            {
                path: 'stock',
                meta: {title: '集团库房库存'},
                permission: 'Pages.GroupStock',
                name: 'stock',
                component: () => System.import('../views/storehouse/stock')
            },
            {
                path: 'indateWarning',
                meta: {title: '集团有效期预警'},
                permission: 'Pages.GroupWarn',
                name: 'indateWarning',
                component: () => System.import('../views/storehouse/indateWarning')
            },
            {
                path: 'repertoryWarning',
                meta: {title: '集团库存预警'},
                permission: 'Pages.GroupWarn',
                name: 'repertoryWarning',
                component: () => System.import('../views/storehouse/repertoryWarning')
            },
            {
                path: 'storageIn',
                meta: {title: '集团入库管理',type:1},
                permission: 'Pages.GroupStockIn',
                operating:['新增','编辑','核对','记账','详情',],
                name: 'storageIn',
                component: () => System.import('../views/storehouse/storage')
            },
            {
                path: 'storageOut',
                meta: {title: '集团出库管理',type:2},
                permission: 'Pages.GroupStockOut',
                operating:['新增','编辑','核对','记账','详情',],
                name: 'storageOut',
                component: () => System.import('../views/storehouse/storage')
            },
            {
                path: 'breakage',
                meta: {title: '集团库存报损',type:3},
                permission: 'Pages.GroupStockBreak',
                operating:['新增','编辑','核对','记账','详情',],
                name: 'breakage',
                component: () => System.import('../views/storehouse/storage')
            },
            {
                path: 'check',
                meta: {title: '集团库存盘点',type:4},
                permission: 'Pages.GroupStockRefund',
                operating:['新增','编辑','核对','记账','详情',],
                name: 'check',
                component: () => System.import('../views/storehouse/storage')
            },
        ]
    },
    {
        path: '/statistics', 
        name: 'statistics',
        permission: 'Pages.Finance',
        meta: {title: '财务报表'},
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'dailyReportSummary',
                meta: {title: '中心收费汇总表'},
                permission: 'Pages.TenantCharge',
                operating:['报表下载','打印'],
                name: 'dailyReportSummary',
                component: () => System.import('../views/statistics/dailyReportSummary')
            },
            {
                path: 'dailyReportDetail',
                meta: {title: '中心收费日报表明细'},
                permission: 'Pages.TenantChargeDaily',
                operating:['报表下载','打印'],
                name: 'dailyReportDetail',
                component: () => System.import('../views/statistics/dailyReportDetail')
            },
            {
                path: 'preDaily',
                meta: {title: '预交金日报表'},
                permission: 'Pages.PrechargeDaily',
                operating:['报表下载','打印'],
                name: 'preDaily',
                component: () => System.import('../views/statistics/preDaily')
            },
            {
                path: 'patientBalance',
                meta: {title: '患者预交金余额报表'},
                permission: 'Pages.PrechargeBalance',
                operating:['报表下载','打印'],
                name: 'patientBalance',
                component: () => System.import('../views/statistics/patientBalance')
            },
            {
                path: 'creditDetail',
                meta: {title: '挂账还款明细报表'},
                permission: 'Pages.CreditDetail',
                operating:['报表下载','打印'],
                name: 'creditDetail',
                component: () => System.import('../views/statistics/creditDetail')
            },
            {
                path: 'creditBalanceDetail',
                meta: {title: '挂账余额明细报表'},
                permission: 'Pages.CreditBalance',
                operating:['报表下载','打印'],
                name: 'creditBalanceDetail',
                component: () => System.import('../views/statistics/creditBalanceDetail')
            },
            // {
            //     path: 'stockforms',
            //     meta: {title: '库房统计图表'},
            //     name: 'stockforms',
            //     component: () => System.import('../views/statistics/stockforms')
            // },
            // {
            //     path: 'girdSong',
            //     meta: {title: '运营财务报表'},
            //     operating:['报表下载'],
            //     permission: 'Pages.FinanceReport',
            //     name: 'girdSong',
            //     component: () => System.import('../views/statistics/girdSong')
            // },
        ]
    },
    // {
    //     path: '/report',
    //     name: 'report',
    //     // permission: 'Pages.FinanceReport',
    //     meta: {title: '统计报表'},
    //     component: main,
    //     children: [
    //         {
    //             path: 'testItem',
    //             meta: {title: '化验项'},
    //             // permission: 'Pages.FinanceReport',
    //             name: 'testItem',
    //             component: () => System.import('../views/report/testItem')
    //         },
    //         {
    //             path: 'qualityMonitoring',
    //             meta: {title: '血透质量检测'},
    //             // permission: 'Pages.FinanceReport',
    //             name: 'qualityMonitoring',
    //             component: () => System.import('../views/report/qualityMonitoring')
                
    //         }
    //     ]
    // },
    {
        path: '/basicDictionary',
        name: 'basicDictionary',
        permission: 'Pages.BaseDict',
        meta: {title: '基础字典'},
        component: main,
        children: [
            {
                path: 'unit',
                meta: {title: '基础单位'},
                permission: 'Pages.BaseUnit',
                name: 'unit',
                operating:['新增','编辑'],
                component: () => System.import('../views/basicDictionary/unit')
            },
            {
                path: 'supplier',
                meta: {title: '供货商'},
                permission: 'Pages.Inventory',
                name: 'supplier',
                operating:['新增','编辑'],
                component: () => System.import('../views/basicDictionary/supplier')
            },
            {
                path: 'manufacturer',  
                meta: {title: '生产厂家'},
                permission: 'Pages.Manufacturer',
                name: 'manufacturer',
                operating:['新增','编辑'],
                component: () => System.import('../views/basicDictionary/manufacturer')
            },
            {
                path: 'maintenanceManufacturer',
                meta: {title: '维修保养厂商'},
                permission: 'Pages.MaintenanceManufacturer',
                name: 'Maintenance',
                operating:['新增','编辑'],
                component: () => System.import('../views/basicDictionary/maintenanceManufacturer')
            },
            {
                path: 'configure',
                meta: {title: '配置字典'},
                permission: 'Pages.SysDictionary',
                name: 'configure',
                operating:['新增','编辑','删除'],
                component: () => System.import('../views/basicDictionary/configure')
            },
        ]
    },
    {
        path: '/setting',
        name: 'setting',
        permission: 'Pages.Setting',
        meta: {title: '系统管理'},
        icon: '&#xe68a;',
        component: main,
        children: [
            {
                path: 'organization',
                permission: 'Pages.Organization',
                meta: {title: '组织架构'},
                operating:['新增','编辑'],
                name: 'organization',
                component: () => System.import('../views/setting/organization')
            },
            {
                path: 'department',
                meta: {title: '部门'},
                permission: 'Pages.OrgDepartment',
                operating:['新增','编辑'],
                name: 'department',
                component: () => System.import('../views/setting/department')
            },
            {
                path: 'post',
                meta: {title: '职位'},
                permission: 'Pages.Position',
                operating:['新增','编辑'],
                name: 'post',
                component: () => System.import('../views/setting/post')
            },
            {
                path: 'user',
                permission: 'Pages.Users',
                meta: {title: 'Users'},
                operating:['新增','编辑','删除','锁定','解锁'],
                name: 'user',
                component: () => System.import('../views/setting/user/user.vue')
            },
            {
                path: 'role',
                permission: 'Pages.Roles',
                meta: {title: 'Roles'},
                operating:['新增','编辑','删除'],
                name: 'role',
                component: () => System.import('../views/setting/role/role.vue')
            },
        ]
    },
    iframeRouters
]

    
export const routers = [
    loginRouter,
    oldHddsRouter,
    locking,
    ...appRouters,
    otherRouters
];
